import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "2869ddec-7dc6-4311-beee-38b3315b9c48",
  publicId: "18",
  name: "Lombard speech",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
